<template>

    <div class="card">
        <div class="card-header pt-3 pb-2">
            <div class="d-flex align-items-center">
                <h6 class="mb-0" style="flex: 1;">Chat: {{ chatHeader }}</h6>
                <div class="d-flex justify-content-center align-items-center gap-2" style="flex: 1;">
                    <input
                        v-show="searchOpen"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        placeholder="Cerca messaggi..."
                        type="text"
                        v-model="search.TEXT.VALUE"
                    >
                    <a href="#" class="text-body" @click.prevent="searchOpen = !searchOpen; if(!searchOpen) search.TEXT.VALUE = ''">
                        <i class="ph-magnifying-glass"></i>
                    </a>
                </div>
                <div class="d-flex justify-content-end" style="flex: 1;">
                    <button class="chat-close-btn" @click.stop="closeComponent">&times;</button>
                </div>
            </div>
        </div>

        <!-- Action toolbar -->
        <div class="card-body bg-light" style="overflow: auto">
            <div v-if="isLoading" class="loading-spinner">
                <div class="spinner"></div>
                <span class="title_chat">Caricamento...</span>
            </div>

            <div class="media-chat-scrollable p-3" @scroll="handleScroll">
                <div class="media-chat vstack gap-2" v-for="group in paginatedList" v-bind:key="group.date">

                    <div class="text-center justify-content-center text-muted mx-0">
                        <span v-if="group.messages.length > 0"  class="badge bg-dark bg-opacity-20 text-reset fs-sm px-2">{{ filters.formatDayWithDate(group.date) }}</span>
                    </div>

                    <div v-for="message in group.messages" v-bind:key="message.ID_MESSAGE" class="media-chat-item align-items-start gap-3 mb-3 w-50" :class="{'media-chat-item-reverse hstack': message.USERNAME == $root.utente.USERNAME, 'hstack': message.USERNAME !== $root.utente.USERNAME}">
                        <a href="#" class="d-block status-indicator-container">
                            <img v-if="message.FK_ID_USER > 0 && message.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',message.URL_AVATAR)" class="w-40px h-40px rounded-pill" alt="" />
                            <div v-if="message.URL_AVATAR == 'placeholder.jpg' || message.FK_ID_USER == 0"><img src="../assets/images/placeholders/placeholder.jpg" class="w-40px h-40px rounded-pill" alt=""></div>
                            <span class="status-indicator "  v-bind:class="$root.getUserStatusClass(message.FK_ID_USER,$root.arrayUtentiAdmin)"></span>
                        </a>
                        <div>
                            <div class="media-chat-message">{{ message.TEXT }}</div>
                            <div class="fs-sm text-muted mt-2">
                                <i v-if="message.FK_ID_USER == $root.utente.ID_UTENTE" class="ph-checks me-1 " v-bind:class="{'text-muted':message.FK_ID_STATO_MESSAGGIO == 1,'text-primary':message.FK_ID_STATO_MESSAGGIO == 2}"></i>
                                {{ message.ORA_INVIO }}
                            </div>
                        </div> 
                    </div>

                </div>
            </div>

        </div>
        <div class="card-footer">

            <div class="d-flex align-items-center gap-2">
                <div class="d-flex gap-1 flex-shrink-0">
                    <div class="btn-group dropup">
                        <button type="button" class="btn btn-light btn-icon border-transparent rounded-pill btn-sm" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="ph-smiley"></i>
                        </button>
                        <ul class="dropdown-menu py-0">
                            <EmojiPicker @select="addEmoji" />
                        </ul>
                    </div>
                    <a href="#" class="btn btn-light btn-icon border-transparent rounded-pill btn-sm" data-bs-popup="tooltip" aria-label="Send file" data-bs-original-title="Send file">
                        <i class="ph-paperclip"></i>
                    </a>
                </div>
                <div class="d-flex flex-grow-1 chat-input-wrapper">
                    <input @keydown.enter.prevent="inserisciMessaggio" @input="handleTyping" class="form-control form-control-content" placeholder="Scrivi un messaggio..." v-model="messaggio.TEXT">
                    <button v-show="messaggio.TEXT != ''" type="button" class="btn btn-primary d-md-none chat-send-mobile" @click="inserisciMessaggio()">
                        <i class="ph-paper-plane-tilt"></i>
                    </button>
                </div>
                <button v-show="messaggio.TEXT != ''" type="button" class="btn btn-primary d-none d-md-inline-flex align-items-center flex-shrink-0" @click="inserisciMessaggio()">
                    Send<i class="ph-paper-plane-tilt ms-2"></i>
                </button>
            </div>

        </div>
    </div>


</template>



<script>

import EmojiPicker from 'vue3-emoji-picker'


export default {
    name: "ChatComp",

    props: {
        chatId: Number,
        chatLabel: { type: String, default: '' },
        utentiSelezionati: {
            type: Array,
            default: () => []
        }
    },

    components:{
        EmojiPicker
    },

    data() {
        return {
            filters: global.filters,
            search: {
                TEXT: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayMessaggi: {messaggi:{}},
            arrayChat: [],
            messaggio: { TEXT: '', FK_ID_USER: this.$root.utente.ID_UTENTE, USERNAME: this.$root.utente.USERNAME },
            utente: { FK_ID_USER_CREATOR: this.$root.utente.ID_UTENTE },
            chatHeader: '' ,
            isSending: false,
            isWriting: false,
            isLoading: false,
            limit:15,
            offset:0,
            allMessagesLoaded: false,
            typingTimeOut: null, 
            chatState: {},
            showEmojiPicker: false,
            searchOpen: false
        };
    },

    methods: {
        handleScroll(event) {
            const container = event.target;
            if (container.scrollTop <= 5 && !this.isLoading && !this.allMessagesLoaded) {
                this.getMessaggiPerChat();
            }
        },

        resetMessageInput(){
            this.messaggio.TEXT = '';
        },

        inserisciMessaggio() {
            const MAX_MESSAGE_LENGTH = 5000;

            // Validazione: messaggio non vuoto
            if(!this.messaggio.TEXT.trim() || this.isSending ){
                return;
            }

            // Validazione: lunghezza massima
            if (this.messaggio.TEXT.length > MAX_MESSAGE_LENGTH) {
                utils.alert.warning(`Messaggio troppo lungo (max ${MAX_MESSAGE_LENGTH} caratteri)`, "Errore", "", 5000);
                return;
            }

            // Sanitizzazione: rimuove tag HTML per prevenire XSS
            this.messaggio.TEXT = this.messaggio.TEXT.replace(/<[^>]*>/g, '');

            // Verifica connessione socket
            const socket = this.$root.appoggio.socket;
            if (!socket || !socket.connected) {
                utils.alert.warning("Connessione socket non attiva", "Errore", "", 5000);
                return;
            }

            this.isSending = true;
            // Crea la data nel formato YYYY-MM-DD direttamente da moment
            const now = global.moment();
            const dateOnly = now.format('YYYY-MM-DD');
            const messaggioClone = {
                ...this.messaggio,
                FK_ID_CHAT : this.chatId,
                DATA_INVIO : dateOnly,
                ORA_INVIO : now.format('HH:mm'),
                URL_AVATAR : this.$root.utente.URL_AVATAR,
                FK_ID_STATO_MESSAGGIO : 1
            };
            console.log('DEBUG inserisciMessaggio - DATA_INVIO creata:', dateOnly);

            if (this.verifySocketConnection()) {
                utils.ajax('chad_2/messaggio', messaggioClone, (response) => {
                    if (response.esito == 0) {
                        messaggioClone.ID_MESSAGE = response.data.id_inserito;
                        this.aggiungiMessaggiInChat(messaggioClone)
                        this.$root.appoggio.socket.emit('sendMessage', messaggioClone);
                        this.$emit('messageSent',messaggioClone);
                        this.messaggio.TEXT = ''; 
                        clearTimeout(this.typingTimeOut);
                        this.$root.appoggio.socket.emit('stopTyping', { chatId: this.chatId, userId: this.$root.utente.ID_UTENTE})
                    }
                    this.isSending = false;
                },false);
            }
            else {
                console.error('Socket non disponibile o sessione scaduta');
                this.isSending = false;
            }
        },

        handleTyping() {
            if (this.verifySocketConnection()) {
                // Invia l'evento "sta scrivendo"
                this.$root.appoggio.socket.emit('typing', { chatId: this.chatId, userId: this.$root.utente.ID_UTENTE, username: this.$root.utente.USERNAME, isWriting:true });
                // Reset del timeout se continua a scrivere
                clearTimeout(this.typingTimeOut);
                // Se non scrive per 1 secondi, inviaMO "ha smesso di scrivere"
                this.typingTimeOut = setTimeout(() => {
                    this.$root.appoggio.socket.emit('stopTyping', { chatId: this.chatId, userId: this.$root.utente.ID_UTENTE, username: this.$root.utente.USERNAME, isWriting:false });
                }, 1000);
            }
        },


        getMessaggiPerChat() {
            if(this.isLoading || this.allMessagesLoaded) return;
            this.isLoading = true;
            utils.ajax('chad_2/messaggi/chat', {FK_ID_CHAT: this.chatId, FK_ID_USER: this.$root.utente.ID_UTENTE,limit: this.limit,offset: this.offset }, (response) => {
                if(response.esito == 0){
                    const nuoviMessaggi = response.data.messaggi;
                    if (response.data.utenti) {
                        this.arrayMessaggi.utenti = response.data.utenti;
                    }
                    if (!nuoviMessaggi || Object.keys(nuoviMessaggi).length == 0) {
                        this.allMessagesLoaded = true;
                    }
                    else {
                        this.offset += this.limit;
                        for (var data in nuoviMessaggi) {
                            if (!this.arrayMessaggi.messaggi[data]) {
                            this.arrayMessaggi.messaggi[data] = [];
                            }
                            this.arrayMessaggi.messaggi[data] = nuoviMessaggi[data].concat(
                            this.arrayMessaggi.messaggi[data]
                            );
                        }
                    }

                    for(const date in nuoviMessaggi) {
                        for(const message of nuoviMessaggi[date]){
                            if(message.FK_ID_USER !== this.$root.ID_UTENTE && message.FK_ID_STATO_MESSAGGIO == 1 ){
                                this.markAsRead()
                            }
                        }
                    }
                    
                    if (this.arrayMessaggi.utenti) {
                        this.chatHeader = this.arrayMessaggi.utenti.map((utente) => utente.USERNAME == this.$root.utente.USERNAME ? 'Tu' : utente.USERNAME).join(', ');
                    }
                   
                }
                this.isLoading = false;
            },() => {this.isLoading = false;},false);   
        },

        getChatUsers() {
            return this.arrayMessaggi && this.arrayMessaggi.utenti ? this.arrayMessaggi.utenti : [];
        },

        markAsRead() {
            if (this.verifySocketConnection()) {
                this.$root.appoggio.socket.emit('markAsRead', { chatId: this.chatId, userId: this.$root.utente.ID_UTENTE });
                utils.ajax('chad_2/messaggi/markAsRead', { idChat: this.chatId, idUtente: this.$root.utente.ID_UTENTE }, (response) => {
                    if (response.esito == 0) {
                        console.log('Messaggi marcati come letti nel DB');
                       this.$emit('updateUnreadMessages', {chatId:this.chatId})
                    } else {
                        console.error('Errore nella marcatura dei messaggi come letti', response);
                    }
                },false);
            }
        },

        handleRecivedMessage(message) {
            console.log("Messaggio ricevuto via socket:", message);
            if (message.FK_ID_CHAT == this.chatId) {
                if(message.FK_ID_USER != this.$root.utente.ID_UTENTE){
                     this.aggiungiMessaggiInChat(message);
                }
                if (this.$root.utente.ID_UTENTE != message.FK_ID_USER) {
                    this.$root.appoggio.socket.emit('markAsRead', { chatId: this.chatId, userId: this.$root.utente.ID_UTENTE });
                    utils.ajax('chad_2/messaggi/updateStatus', { idMessaggio: message.ID_MESSAGE, newStatus: 2 }, (response) => {
                        if (response.esito == 0) {
                            console.log('Messaggio aggiornato come letto');
                            message.FK_ID_STATO_MESSAGGIO = 2; 
                        }
                    },false);
                }
            }
            this.isWriting = false;
        },

        aggiungiMessaggiInChat(message){
            // Normalizza DATA_INVIO al formato YYYY-MM-DD (estrae solo la parte della data, non l'ora)
            let dateKey = message.DATA_INVIO;
            console.log('DEBUG aggiungiMessaggiInChat - DATA_INVIO ricevuta:', dateKey, 'tipo:', typeof dateKey);

            if (dateKey && typeof dateKey == 'string') {
                if (dateKey.includes(' ')) {
                    // Se contiene ora, estrai solo la data
                    dateKey = dateKey.split(' ')[0];
                }
                // Valida che sia nel formato YYYY-MM-DD
                if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) {
                    console.warn('Data in formato non valido:', dateKey, '- converto con formatDateReverse');
                    // Se non è nel formato corretto, prova a convertirlo
                    dateKey = filters.formatDateReverse(filters.formatDate(new Date(dateKey)));
                }
            }
            message.DATA_INVIO = dateKey;
            console.log('DEBUG aggiungiMessaggiInChat - DATA_INVIO normalizzata:', dateKey);

            if(!this.arrayMessaggi.messaggi[dateKey]){
                this.arrayMessaggi.messaggi[dateKey] = [];
            }
            this.arrayMessaggi.messaggi[dateKey].push(message);
            if (this.$root.utente.ID_UTENTE != message.FK_ID_USER) {
                message.FK_ID_STATO_MESSAGGIO = 2;
            }
        },

        verifySocketConnection() {
            if (!this.$root.appoggio || !this.$root.appoggio.socket) {
                console.warn("Socket non disponibile, tentando la riconnessione...");
                this.reconnectSocket();
                return false;
            }
            return true;
        },
            
        reconnectSocket() {
            if (this.$root.utente && this.$root.utente.ID_UTENTE) {
                this.$root.appoggio.socket = io(this.$root.CHAT_PATH); 
                this.setupSocketListeners(); 
            }
        },

        setupSocketListeners() {
            this._onReceiveMessage = this.handleRecivedMessage;
            this._onMessagesRead = (data) => {
                if (data.chatId == this.chatId) {
                    for (let dateKey in this.arrayMessaggi.messaggi) {
                        const dayMessages = this.arrayMessaggi.messaggi[dateKey];
                        for (let i = 0; i < dayMessages.length; i++) {
                            const message = dayMessages[i];
                            if (message.FK_ID_USER == this.$root.utente.ID_UTENTE) {
                                message.FK_ID_STATO_MESSAGGIO = 2;
                            }
                        }
                    }
                }
            };
            this._onTyping = (data) => {
                if (data.chatId == this.chatId && data.userId !== this.$root.utente.ID_UTENTE) {
                    this.$emit('isWriting', { chatId: this.chatId, userId: data.userId, username: data.username, isWriting: true });
                }
            };
            this._onStopTyping = (data) => {
                if (data.chatId == this.chatId && data.userId !== this.$root.utente.ID_UTENTE) {
                    this.$emit('stopWriting', { chatId: this.chatId, userId: data.userId, username: data.username, isWriting: false });
                }
            };
            this.$root.appoggio.socket.on('receiveMessage', this._onReceiveMessage);
            this.$root.appoggio.socket.on('messagesRead', this._onMessagesRead);
            this.$root.appoggio.socket.on('typing', this._onTyping);
            this.$root.appoggio.socket.on('stopTyping', this._onStopTyping);
        },

        closeComponent() {
            this.$emit('close');
        },

        toogleEmojiPicker(){
            this.showEmojiPicker = !this.showEmojiPicker;
        },

        addEmoji(emoji){
            this.messaggio.TEXT += emoji.i
            this.showEmojiPicker = false
        },

        flattenMessagesByDate(arrayMessaggi){
            let result = [];
            Object.keys(arrayMessaggi.messaggi).forEach(date => {
                arrayMessaggi.messaggi[date].forEach(message => {
                    result.push({
                        ...message,
                        DATA_INVIO: date 
                    });
                });
            });
            return result;
        },

        groupMessagesByDate(filteredMessages){
            return filteredMessages.reduce((acc, message) => {
                const date = message.DATA_INVIO;
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(message);
                return acc;
            }, {});
        },

        filterMessages(messagesArray,searchText){
            return messagesArray.filter(message => {
                return (
                    message.TEXT.toLowerCase().includes(searchText.toLowerCase()) ||
                    message.USERNAME.toLowerCase().includes(searchText.toLowerCase())
                );
            });       
        },


    },

    computed: {
        // Passaggio 1: Flatten messages into an array
        orderedMessagesFlat() {
            return this.flattenMessagesByDate(this.arrayMessaggi)
            .sort((a, b) => {
                const dateDiff = a.DATA_INVIO.localeCompare(b.DATA_INVIO); // Ordina per data crescente (più vecchi prima)
                if (dateDiff == 0) {
                    return a.ORA_INVIO.localeCompare(b.ORA_INVIO); // Ordina per ora crescente (come stringhe)
                }
                return dateDiff;
            });
        },

            // Step 2: Filtra i messaggi ordinati
        filteredOrderedMessagesFlat() {
            const searchText = this.search.TEXT.VALUE.toLowerCase();
            return this.orderedMessagesFlat.filter(message => {
                return (
                    message.TEXT.toLowerCase().includes(searchText) ||
                    message.USERNAME.toLowerCase().includes(searchText)
                );
            });
        },

            // Step 3: Ordina DATE e MESSAGGI invertiti per compensare flex-direction:column-reverse del CSS
        paginatedList() {
            const searchText = this.search.TEXT.VALUE.toLowerCase();

            const convertToYYYYMMDD = (dateStr) => {
                if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
                if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
                    const [day, month, year] = dateStr.split('/');
                    return `${year}-${month}-${day}`;
                }
                return dateStr;
            };

            // Date in ordine INVERSO (più recente prima) per compensare flex-direction:column-reverse
            const sortedDates = Object.keys(this.arrayMessaggi.messaggi)
                .sort((a, b) => convertToYYYYMMDD(a).localeCompare(convertToYYYYMMDD(b)))
                .reverse();

            // Per ogni data, filtra e ordina messaggi per ora (dal più vecchio al più recente)
            return sortedDates.map(date => {
                const messages = [...(this.arrayMessaggi.messaggi[date] || [])]
                    .filter(msg => !searchText ||
                        msg.TEXT.toLowerCase().includes(searchText) ||
                        msg.USERNAME.toLowerCase().includes(searchText))
                    .sort((a, b) => (a.ORA_INVIO || '').localeCompare(b.ORA_INVIO || ''));
                return { date, messages };
            }).filter(group => group.messages.length > 0);
        }
    },

    watch: {
        chatId(newVal, oldVal) {
            if (newVal != oldVal) {
                this.arrayMessaggi = {messaggi: {}};
                this.offset = 0;
                this.allMessagesLoaded = false;
                this.isLoading = false;
                this.getMessaggiPerChat();
                this.resetMessageInput();
            }
        },
        chatLabel: {
            immediate: true,
            handler(val) { if (val) this.chatHeader = val; }
        }
    },
    
    created() {
        this.getMessaggiPerChat();
        if(this.verifySocketConnection()){
            this.setupSocketListeners();
            // Join alla room della chat specifica
            this.$root.appoggio.socket.emit('joinChat', this.chatId);
            console.log(`DEBUG: Joined chat room ${this.chatId}`);
        }
    },

    beforeUnmount(){
        if (this.$root.appoggio && this.$root.appoggio.socket) {
            this.$root.appoggio.socket.emit('leaveChat', this.chatId);
            this.$root.appoggio.socket.off('receiveMessage', this._onReceiveMessage);
            this.$root.appoggio.socket.off('messagesRead', this._onMessagesRead);
            this.$root.appoggio.socket.off('typing', this._onTyping);
            this.$root.appoggio.socket.off('stopTyping', this._onStopTyping);
        }
    }
}
</script>

<style scoped>
    .message{padding:10px;border-radius:15px;margin:5px;max-width:60%;position:relative;word-wrap:break-word}
    .message.sent{background-color:#addefb;align-self:flex-end;text-align:right}
    .message.received{background-color:#ceedf9;align-self:flex-start;text-align:left}
    .username{font-weight:700;color:#005180}
    .status{font-size:.75em;color:#888;position:absolute;bottom:5px;right:10px}
    .input-group{display:flex;align-items:center;margin-bottom:0}
    .input{border-radius:30px;flex:1;margin-right:10px}
    .circle-btn{border-radius:50%;background-color:#005180;height:38px;width:40px;display:flex;align-items:center;justify-content:center;border:none}
    .circle-btn i{color:#fff;font-size:16px}
    .chat-close-btn{background:none;border:none;font-size:1.5rem;font-weight:700;cursor:pointer;color:#888;padding:0;line-height:1}
    .chat-close-btn:hover{color:#000}
    @media (min-width:769px){
        .card{height:100%;display:flex;flex-direction:column}
        .card .card-body{flex:1;overflow:hidden;min-height:0}
        .media-chat-scrollable{height:100%;max-height:none;overflow-y:auto}
    }
    @media (max-width:767px){
        .chat-input-wrapper .form-control{border-top-right-radius:0;border-bottom-right-radius:0}
        .chat-send-mobile{border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px}
    }
</style>
